import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { styled } from "goober";
import { Button } from "clutch/src/Button/Button.jsx";

import EditIcon from "@/inline-assets/edit.svg";

// TODO: i18n - button is fixed width, text doesn't fit in some languages
const EditButton = styled(Button)`
  .edit {
    width: var(--sp-20);
    height: var(--sp-9);
  }
  &:hover path {
    fill: var(--shade0);
  }
  & path {
    fill: var(--shade1);
  }
`;

export default function EditSettingsButton({ editClick, modal }) {
  const { t } = useTranslation();
  const click = useCallback(() => editClick(modal), [editClick, modal]);

  return (
    <EditButton
      className="form-button edit"
      iconLeft={<EditIcon width="18px" height="18px" />}
      onClick={() => click()}
    >
      {t("common:settings.edit", "Edit")}
    </EditButton>
  );
}

export const editButton = <EditSettingsButton />;
